import { Cols } from "../shared/Consts";
import usePortfolio from "../hooks/PortfolioProvider";
import { usePath } from "../libs/path/PathProvider";
import PortUtils from "../portlibs/PortUtils";
import Portfolio from "../models/Portfolio";
import HoldingTable from "../components/widgets/HoldingTable";
import useDateRangeFilter from "../portlibs/DateRangeFilterProvider";
import FixedToolbar from "../components/fixed/FixedToolbar";
import { useCallback } from "react";
import Utils from "../libs/Utils";

const COLS = [Cols.name, Cols.note, Cols.date, Cols.maturity, Cols.maturityMonth, Cols.yield, Cols.holdingCost, Cols.holdingValue, Cols.a_payout, Cols.dividend, Cols.mwPercent];
    
export default function Home(){
    const {query} = usePath()
    const {account,currency,filter,showDisposed} = PortUtils.getFilter(query)
    const {portfolio} = usePortfolio()
    const {end} = useDateRangeFilter()
    
    let rows = portfolio.termHoldings(null, 0, filter, account)
    if (!PortUtils.dateEq(end, new Date())) rows = PortUtils.trimHoldings(rows, end.getTime())

    rows = rows.filter(holding => {
        if (!showDisposed && PortUtils.isZero(holding.quantity)) return false
        else if (holding.transactions.length==0) return false
        else return !filter || holding.shouldFilter(filter)
    })

    const total = Portfolio.buildTotal(currency, rows, 0);
    const onExport = useCallback(() => Utils.exportFile(PortUtils.toCSV(rows, COLS), `Fixed ${Utils.formatDate("yyyy-MM-dd", new Date())}.csv`), [rows])
    return <>
        <FixedToolbar onExport={onExport}/>
        <div id="fixed" className="flex1 scroller">
            <HoldingTable tableName="fixed" cols={COLS} rows={rows} footer={total}/>
        </div>
    </>
    
}